module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget",
    attrs: {
      "id": "topp02"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 fld"
  }, [(_vm.component_view.paymentDetails) ? _c('div', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    staticStyle: {
      "float": "right",
      "margin-top": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm', '', '')
      }
    }
  }, [_vm._v("Back to Form")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.payment_details_data).length !== 0)) ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "3em"
    }
  }, [_c('h4', [_vm._v("Payment Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h6', [_c('b', [_vm._v("Name")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.payment_details_data.customerName) + "\r\n                                        ")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "line-height": "1.8"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), (_vm.payment_details_data.cninsurance_form_policy_amount_with_discount > 0) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('del', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount))])]), _vm._v(" \r\n                                                    "), _c('span', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount_with_discount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("(" + _vm._s(_vm.payment_details_data.cninsurance_form_policy_discount) + "% off)")])]) : _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_commission))])]), _vm._v(" "), (Number(_vm.payment_details_data.cninsurance_form_policy_stamp_duty) > 0) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_stamp_duty))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦ ")]), _vm._v(_vm._s(_vm.payment_details_data.total_amount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentModeModal(_vm.payment_details_data)
      }
    }
  }, [_vm._v("Proceed")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm')
      }
    }
  }, [_vm._v("Back to Form")])]) : _vm._e(), _vm._v(" "), (_vm.component_view.previewForm) ? _c('div', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    staticStyle: {
      "float": "right",
      "margin-top": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('fillForm', '', '')
      }
    }
  }, [_vm._v("Back to Form")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.cninsurance).length !== 0)) ? _c('div', [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("First Name")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_first_name) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Last Name")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_last_name) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Date Of Birth")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_dob) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Gender")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_gender) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Email Address")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_email) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Phone Number")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_phone) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Address")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_address) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Registration Number")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_reg_no) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.cninsurance.cninsurance_form_vehicle_class) ? _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Class")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_class.cninsurance_form_variable_name) + "\r\n                                        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Number Plate")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_number_plate) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Make (Manufacturer)")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_make) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Model")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_model) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Chassis Number")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_chassis_number) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Vehicle Engine Number")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_vehicle_engine_number) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Year of Manufacture")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_year_of_manufacture) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Year of Purchase")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_year_of_purchase) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Policy Holder Type")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_policyholder_type.cninsurance_form_variable_name) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 wn-h-list"
  }, [_c('h6', [_c('b', [_vm._v("Company / Organisation Name")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance.cninsurance_form_company_name) + "\r\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitCNInsuranceForm
    }
  }, [_vm._v("Submit")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('fillForm')
      }
    }
  }, [_vm._v("Back to Form")])]) : _vm._e(), _vm._v(" "), (_vm.component_view.fillForm) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "background-white xp20 mb30"
  }, [_c('h4', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.cninsurance_listing.cninsurance_name) + " Form")]), _vm._v(" "), _c('div', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-md-6 wn-pd0"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_first_name),
      expression: "cninsurance.cninsurance_form_first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your First Name"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_last_name),
      expression: "cninsurance.cninsurance_form_last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your Last Name"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_dob),
      expression: "cninsurance.cninsurance_form_dob"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "Enter Date of Birth"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_dob = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_gender),
      expression: "cninsurance.cninsurance_form_gender"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _c('option', [_vm._v("Male")]), _vm._v(" "), _c('option', [_vm._v("Female")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_email),
      expression: "cninsurance.cninsurance_form_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Email Address"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_phone),
      expression: "cninsurance.cninsurance_form_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter Phone Number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_address),
      expression: "cninsurance.cninsurance_form_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your Address"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_reg_no),
      expression: "cninsurance.cninsurance_form_vehicle_reg_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Registration Number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_vehicle_reg_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_vehicle_reg_no = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(13), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_class),
      expression: "cninsurance.cninsurance_form_vehicle_class"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_vehicle_class = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.form_vechicle_classes), function(vechicle_class) {
    return _c('option', {
      domProps: {
        "value": vechicle_class
      }
    }, [_vm._v(_vm._s(vechicle_class.cninsurance_form_variable_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_number_plate),
      expression: "cninsurance.cninsurance_form_vehicle_number_plate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Number Plate"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_vehicle_number_plate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_vehicle_number_plate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(15), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_make),
      expression: "cninsurance.cninsurance_form_vehicle_make"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_vehicle_make = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getVechicleManufacturerModels(_vm.cninsurance.cninsurance_form_vehicle_make)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.car_manufacturers), function(vechicle_make) {
    return _c('option', {
      domProps: {
        "value": vechicle_make
      }
    }, [_vm._v(_vm._s(vechicle_make))])
  })], 2)]), _vm._v(" "), ((_vm.cninsurance.cninsurance_form_vehicle_model != '')) ? _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(16), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_model),
      expression: "cninsurance.cninsurance_form_vehicle_model"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_vehicle_model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.car_models), function(vechicle_model) {
    return _c('option', {
      domProps: {
        "value": vechicle_model
      }
    }, [_vm._v(_vm._s(vechicle_model))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_chassis_number),
      expression: "cninsurance.cninsurance_form_vehicle_chassis_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Chassis Number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_vehicle_chassis_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_vehicle_chassis_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_vehicle_engine_number),
      expression: "cninsurance.cninsurance_form_vehicle_engine_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Engine Number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_vehicle_engine_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_vehicle_engine_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_year_of_manufacture),
      expression: "cninsurance.cninsurance_form_year_of_manufacture"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1900",
      "max": "2099",
      "step": "1",
      "placeholder": "Enter the Year of Manufacture"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_year_of_manufacture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_year_of_manufacture = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_year_of_purchase),
      expression: "cninsurance.cninsurance_form_year_of_purchase"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1900",
      "max": "2099",
      "step": "1",
      "placeholder": "Enter the Year of Purchase"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_year_of_purchase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_year_of_purchase = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pd0"
  }, [_vm._m(21), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_policyholder_type),
      expression: "cninsurance.cninsurance_form_policyholder_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_form_policyholder_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please Select")]), _vm._v(" "), _vm._l((_vm.form_policyholder_types), function(policyholder_type) {
    return _c('option', {
      domProps: {
        "value": policyholder_type
      }
    }, [_vm._v(_vm._s(policyholder_type.cninsurance_form_variable_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 wn-pdr0 wn-xpdr0"
  }, [_c('label', [_vm._v("Company / Organisation Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_form_company_name),
      expression: "cninsurance.cninsurance_form_company_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Company / Organisation Name"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_form_company_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_form_company_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-5 col-xs-12 wn-pd0"
  }, [_c('label', [_vm._v("Discount Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_discount_code),
      expression: "cninsurance.cninsurance_discount_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Discount Code, if you have"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_discount_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_discount_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 col-xs-12 wn-pd0"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms_cn_agree),
      expression: "terms_cn_agree"
    }],
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "-2em",
      "float": "left"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms_cn_agree) ? _vm._i(_vm.terms_cn_agree, null) > -1 : (_vm.terms_cn_agree)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms_cn_agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms_cn_agree = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms_cn_agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms_cn_agree = $$c
        }
      }
    }
  }), _vm._m(22)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(this.$route.params.ref == 'resolve') ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.wn_catch()))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), (((_vm.cninsurance.cninsurance_form_order_ref) && (_vm.cninsurance.cninsurance_form_order_ref != ''))) ? _c('div', {
    staticClass: "center"
  }, [(_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm')
      }
    }
  }, [_vm._v("Preview and Submit")]) : _vm._e(), _vm._v(" "), ((Object.keys(_vm.cninsurance).length !== 0)) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm')
      }
    }
  }, [_vm._v("Preview")]) : _vm._e()]) : _c('div', {
    staticClass: "center"
  }, [(_vm.terms_cn_agree) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('previewForm')
      }
    }
  }, [_vm._v("Preview and Submit")]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), _c('cnpayment-modal', {
    attrs: {
      "payment_data": _vm.set_payment_data,
      "payment_object": _vm.set_payment_object
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("InsureMoto Policy Cost:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("InsureMoto Processing Fee: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Above Threshold Limit Charge (ATLC):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Total Amount: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("First Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Last Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Date Of Birth"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Gender"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Email Address"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Phone Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Registration Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Class"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Number Plate"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Make (Manufacturer) "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Model"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Chassis Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Vehicle Engine Number"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Year of Manufacture"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Year of Purchase"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Policy Holder Type"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": "-2em",
      "float": "left"
    }
  }, [_vm._v("Please accept "), _c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c64a4a4"}!./src/templates/CNInsuranceForm/template.html
// module id = 277
// module chunks = 0